import { createFileRoute, useParams } from '@tanstack/react-router';
import { NotFound } from '@/components/Error/NotFound';
import { FillScreen, VStack } from '@/components/Layout';
import { ViewportLoader } from '@/components/Loading';
import { DeviceGroupDetailView } from '@/features/device-group/components/DeviceGroupDetail';
import { useDeviceGroupDetail } from '@/features/device-group/query';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import HeaderDetailDeviceGroup from './-components/HeaderDetailDeviceGroup';
export const Route = createFileRoute('/_staff/devices/_list/settings/device-groups/$id/')({
  component: RouteComponent
});
function RouteComponent() {
  const {
    id
  } = useParams({
    from: '/_staff/devices/_list/settings/device-groups/$id/'
  });
  const {
    data,
    isPending,
    isError
  } = useDeviceGroupDetail(id);
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.devices.settings.deviceGroups.detail.header'
  });
  useDocumentTitle(data?.name ?? t('title'));
  if (isPending && !data) {
    return <ViewportLoader />;
  }
  if (isError || !data) {
    return <NotFound />;
  }
  return <FillScreen className="flex min-h-0 flex-col overflow-hidden">
      <div className="shrink-0 border-b border-neutral-muted-border">
        <HeaderDetailDeviceGroup deviceGroupId={id} />
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto pt-6 pb-6">
        <VStack className="gap-7">
          <DeviceGroupDetailView deviceGroupId={id} detail={data} />
        </VStack>
      </div>
    </FillScreen>;
}